























































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'

@Component

export default class ComponentAmericasmedicalcityTipoAnestesia extends Vue {
  get getSolicitacaoStore() {
    const solicitacao = getModule(SolicitacaoStore, this.$store)
    return solicitacao
  }

  get getErrorMessage() {
    return this.getSolicitacaoStore.errorMessage
  }
}
